import { render, staticRenderFns } from "./StatisticsTraders.vue?vue&type=template&id=4c7b27cd&scoped=true&"
import script from "./StatisticsTraders.vue?vue&type=script&lang=js&"
export * from "./StatisticsTraders.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTraders.vue?vue&type=style&index=0&id=4c7b27cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b27cd",
  null
  
)

export default component.exports